import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Concept from "@/pages/home/components/Concept";
import Features from "@/pages/home/components/Features";
import Menu from "@/pages/home/components/Menu";
import StoreInfo from "@/pages/home/components/StoreInfo";
import OpenGift from "@/pages/home/components/OpenGift";
import News from "@/pages/home/components/News";
import Recruit from "@/pages/home/components/Recruit";
import Footer from "@/pages/home/components/Footer";
import MobileCTABar from "@/pages/home/components/MobileCTABar";
import Seo from "@/pages/home/components/Seo";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-950 pb-14 lg:pb-0">
      <Seo />
      <Navbar />
      <Hero />
      <Menu />
      <Concept />
      <Features />
      <StoreInfo />
      <OpenGift />
      <News />
      <Recruit />
      <Footer />
      <MobileCTABar />
    </main>
  );
}
